module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 13.904 7.578",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }